import { ukraineOption } from '../../constants';
import { getAddressInitialValues, getDocumentsInitialValues } from '../../utils';
import { EMPTY_GOVERNING_PERSON } from './constants';
import { TManagmentStructure } from './types';

export const getInitialValues = (formData: TManagmentStructure) => ({
  type: formData?.type || '',
  lastName: formData?.lastName || '',
  firstName: formData?.firstName || '',
  middleName: formData?.middleName || '',
  birthDate: formData?.birthDate || null,
  identificationNumber: formData?.identificationNumber || '',
  foreignTaxNumber: formData?.foreignTaxNumber || '',
  citizenshipCountry: formData?.citizenshipCountry || ukraineOption,
  residenceCountry: formData?.residenceCountry || ukraineOption,
  birthCountry: formData?.birthCountry || ukraineOption,
  birthPlace: formData?.birthPlace || '',
  documents: getDocumentsInitialValues(formData),
  position: formData?.position || null,
  address: getAddressInitialValues(formData),
  isAccountHolder: formData?.isAccountHolder ?? null,
  hasNoGoverningPersons: formData?.hasNoGoverningPersons || false,
  isHeadNew: formData?.isHeadNew || false,
  isInBankBlackList: formData?.isInBankBlackList || false,
  isInTerList: formData?.isInTerList || false,
  governingPersons: formData?.hasNoGoverningPersons
    ? []
    : formData?.governingPersons && formData?.governingPersons?.length > 0
      ? formData.governingPersons.map((person) => ({
          lastName: person?.lastName || null,
          firstName: person?.firstName || null,
          middleName: person?.middleName || null,
          identificationNumber: person?.identificationNumber || null,
          birthDate: person?.birthDate || null,
          citizenshipCountry: person?.citizenshipCountry || ukraineOption,
          residenceCountry: person?.residenceCountry || ukraineOption,
          position: person?.position || null,
          address: getAddressInitialValues(person),
        }))
      : [EMPTY_GOVERNING_PERSON],
});
